import { render, staticRenderFns } from "./comm.vue?vue&type=template&id=ee77b36e&scoped=true"
import script from "./comm.vue?vue&type=script&lang=js"
export * from "./comm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee77b36e",
  null
  
)

export default component.exports